import { IStudyQuest } from "./shared.interface";

export const ADMIN_BASE_URL = "";
export const PATIENT_BASE_URL = "";
export const SITE_ADMIN_BASE_URL = "";

export const DateFormat: string = "DD.MM.YYYY";
export const DateFormatView: string = "dd MMM YYYY";
export const AES_SECRET_KEY = "0123456789123456";

export const NUMBER_PATTERN = /^[0-9]+$/;
export const DECIMAL_PATTERN = /^[0-9]*(\.\d{1,2})?$/;
export const DECIMAL_SINGLE_PATTERN = /^[0-9]*(\.\d{1,1})?$/;
export const DECIMAL_FULL_PATTERN = /^[0-9]*(\.\d{1,})?$/;
export const NAME_PATTERN = /^[a-zA-Z _-]+$/;
export const ALPHA_NUMARIC_PATTERN = /^[a-zA-Z0-9 ._-]+$/;
export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@!$%&?+\-*/#])[A-Za-z\d@!$%&?+\-*/#]{5,16}$/;
export const ALLOWED_SPECIAL_CHAR = "@ ! $ % & ? + - * / #";

export const GERMAN_REGEX = /^\d{1,3}(?:\.\d{3})*(?:,\d+)?$|^\d+(?:,)?\d+$/;

export const PASSWORD_PATTERN_ERROR = `Mindestens 5 und höchstens 16 Zeichen, mindestens ein Großbuchstabe, ein Kleinbuchstabe, eine Zahl und ein Sonderzeichen.`;

export const QuestDisabledStatus = "DISABLED";
export const QuestActiveStatus = "ACTIVE";
export const QuestCompletedStatus = "COMPLETED";

export const ScheduledStudyType: string = "Scheduled/Fixed-Interval";
export const RollingStudyType: string = "Rolling/Daily Continuous Design";
export const StudyTypeList: any[] = [ScheduledStudyType, RollingStudyType];

export const ChatBotQuestList: IStudyQuest[] = [];

export const AdminQuestList: IStudyQuest[] = [];

export const DailyQuestionnaires: IStudyQuest[] = [
    {
        QuestId: "Jupiter_Study_01",
        Description: "Jupiter Study"
    }
];



